import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroImage, heroMetrics, paymentNote } from '../data/content';
export function Hero() {
  return <section className="w-full bg-ink px-5 pb-12 pt-10 sm:pb-20 sm:pt-16" data-id="element-109" data-mp="9ka5gxomiqwe">
      <div className="mx-auto flex max-w-3xl flex-col items-center text-center" data-id="element-110" data-mp="9ih0dmtnseqi">
        <span className="mb-6 inline-block rounded-full border border-primary bg-primary/20 px-4 py-1.5 text-[11px] font-semibold uppercase tracking-wider text-surface" data-id="element-111" data-mp="4jm4pkalevoz">
          Método visual de coreano desde cero · 2026
        </span>

        <h1 className="font-display text-[26px] font-bold leading-tight text-surface sm:text-5xl md:text-[56px]" data-id="element-112" data-mp="sarvgui2n8e2">
          Pasá de no entender ni una letra a <span className="text-pink-light" data-id="element-113" data-mp="nbyhl0yvhfdd">leer Hangul</span> y armá
          tus primeras frases en coreano en 30 días.
        </h1>

        <figure className="relative mt-8 w-full max-w-[520px] sm:mt-10" data-id="element-114" data-mp="382fhvvzgliim">
          <div className="relative overflow-hidden rounded-media shadow-media" data-id="element-115" data-mp="384jsewrv5frv">
            <img src={heroImage} alt="Ebook Aprende Coreano Fácil junto a sus 4 bonos" width="1200" height="1200" fetchPriority="high" loading="eager" decoding="async" sizes="(max-width: 560px) calc(100vw - 40px), 520px" className="block aspect-square w-full object-cover" data-id="element-116" data-mp="3j923tk0h7itf" />
          </div>
          <div className="absolute -bottom-4 -left-2 flex h-20 w-20 flex-col items-center justify-center rounded-full border-2 border-surface bg-pink text-surface shadow-cta sm:-left-5 sm:h-24 sm:w-24" data-id="element-117" data-mp="3e84m18jdoqsg">
            <ShieldCheckIcon className="h-6 w-6 sm:h-7 sm:w-7" aria-hidden="true" data-id="element-118" data-mp="35aatm8oqihak" />
            <span className="mt-0.5 text-[10px] font-extrabold uppercase leading-tight sm:text-[11px]" data-id="element-119" data-mp="2qkwiow5ifrt2">
              Garantía
              <br data-id="element-120" data-mp="2vj7s55rw80ar" />7 días
            </span>
          </div>
          <figcaption className="px-3 pt-6 text-center text-xs font-medium text-surface/75 sm:text-sm" data-id="element-121" data-mp="2hix2g62bkrr6">
            El método completo, listo para empezar hoy mismo.
          </figcaption>
        </figure>

        <p className="mt-6 max-w-xl text-sm leading-relaxed text-surface/80 sm:text-base" data-id="element-122" data-mp="s3351dk4moxj">
          6 módulos paso a paso + 4 bonos + más de 100 fichas visuales. Hangul, pronunciación,
          vocabulario y frases reales de K-dramas y K-pop, con un método simple, visual y ordenado.
          Aunque nunca hayas estudiado idiomas.
        </p>

        <div className="mt-8 w-full max-w-md" data-id="element-123" data-mp="dbapp1kc1avt">
          <CTAButton data-id="element-124" data-mp="1b15lv52itfk9" />
          <p className="mt-3 text-xs leading-relaxed text-surface/65" data-id="element-125" data-mp="1b0ds7zshhrwm">{paymentNote}</p>
        </div>

        <div className="mt-8 grid w-full grid-cols-2 overflow-hidden rounded-2xl border border-surface/10 bg-ink-card sm:mt-10 sm:grid-cols-4" data-id="element-126" data-mp="162c8dcn8hok3">
          {heroMetrics.map((metric, index) => <div key={metric.label} className={`flex flex-col items-center border-surface/10 px-4 py-5 sm:py-6 ${index % 2 !== 0 ? 'border-l' : ''} ${index >= 2 ? 'border-t' : ''} sm:border-t-0 sm:border-l sm:first:border-l-0`} data-id="element-127" data-mp="x032j02wujd1" data-mpi={index}>
              <span className="font-display text-4xl font-bold text-primary-soft" data-id="element-128" data-mp="3hq2852whggch">{metric.value}</span>
              <span className="mt-1 text-xs font-medium text-surface/85 sm:text-sm" data-id="element-129" data-mp="1x784bltydnt2">{metric.label}</span>
            </div>)}
        </div>
      </div>
    </section>;
}